import CheckBox from "devextreme-react/check-box";
import TextBox from "devextreme-react/text-box";
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal,Confirm } from 'semantic-ui-react';
import { emailApi } from "../../../../api/emailApi";
import { emailFileDinhKemChiTietApi } from '../../../../api/emailFileDinhKemChiTietApi';
import { mauThuKetQuaApi } from '../../../../api/mauThuKetQuaApi';
import { DangerButton, DefaultButton } from '../../../../components/editor/button';
import ComboboxTruong from '../../../../components/editor/cmb_truong';
import { FormGroup } from '../../../../components/form-group';
import { showNotify } from '../../../../helpers/toast';
import NoiDungModal from "../../ket-qua-thi/noi-dung-thu-modal/NoiDungModal";
import styles from "./MauThuDetailModal.module.css";

const MauThuDetailModal = ({
    mauThuTuyenSinh,
    onSuccess,
    onClose,
    isPreview
}) => {
    const [formData, setFormData] = useState(mauThuTuyenSinh || { id: 0, dinh_kem_ket_qua_thi: false });
    const { dm_coso_id } = useSelector(x => x.coSo);
    const { nam_hoc } = useSelector(x => x.namHoc);
    const [showFileInput, setShowFileInput] = useState(false);
    const [fileDinhKemChiTietDeletedId, setFileDinhKemChiTietDeletedId] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [attachFilesUploaded, setAttachFilesUploaded] = useState([]);
    const inputRef = useRef(null);

    const ref = useRef()
    useEffect(() => {
        setFormData(mauThuTuyenSinh ? { ...mauThuTuyenSinh } : {
            id: 0,
            dm_coso_id,
            nam_hoc
        })
        handleGetEmaiFileDinhKem();

    }, [mauThuTuyenSinh])
    const handleGetDetail = async () => {
        if (mauThuTuyenSinh && mauThuTuyenSinh.id > 0) {
            const res = await mauThuKetQuaApi.Detail(mauThuTuyenSinh.id);
            if (res.is_success) {
                setFormData(res.data)
            }
        }
    }
    const handleSubmit = async () => {
        if (formData.id > 0) {
            const res = await mauThuKetQuaApi.Update(formData);
            if (res.is_success) {
                const formfile = new FormData();
                selectedFiles.forEach((file) => {
                    formfile.append('formFiles', file);
                });
                const resAttach = await emailApi.UploadMauThu({
                    formFiles: formfile,
                    ex_mauthu_ketqua_id: formData.id,
                });
                if (resAttach.is_success) {
                    setSelectedFiles([])
                    showNotify({ text: "Cập nhật thành công", type: "success" })
                    onSuccess();
                }
                else {
                    showNotify({ text: "Có lỗi", type: "error" })
                }


            } else {
                showNotify({ text: "Có lỗi", type: "error" })

            }
        } else {
            const res = await mauThuKetQuaApi.Insert(formData);
            if (res.is_success) {
                const formfile = new FormData();
                selectedFiles.forEach((file) => {
                    formfile.append('formFiles', file);
                });
                const resAttach = await emailApi.UploadMauThu({
                    formFiles: formfile,
                    ex_mauthu_ketqua_id: res.data,
                });
                if (resAttach.is_success) {
                    setSelectedFiles([])
                    showNotify({ text: "Thêm mới thành công", type: "success" })
                    onSuccess();
                }
                else {
                    showNotify({ text: "Có lỗi", type: "error" })
                }

            } else {
                showNotify({ text: "Có lỗi", type: "error" })
            }
        }
    }
    const handleDeleteFile = (index) => {
        const updatedFiles = [...selectedFiles];
        updatedFiles.splice(index, 1);
        setSelectedFiles(updatedFiles);
    };
    const toggleFileInput = () => {
        setShowFileInput(!showFileInput);
    };
    const handleUploadFiles = async (e) => {
        const newFiles = Array.from(e.target.files);
        const updatedFiles = [...selectedFiles];
        newFiles.forEach((newFile) => {
            const isFileExists = selectedFiles.some(
                (file) => file.name === newFile.name
            );
            if (!isFileExists) {
                updatedFiles.push(newFile);
            }
        });
        setSelectedFiles(updatedFiles);
    };
    const fileCellRender = () => {
        return (
            <div>
                {attachFilesUploaded &&
                    attachFilesUploaded.map((x, idx) => {
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '5px',
                                    paddingBottom: '5px',
                                }}
                            >
                                <FilePreView file={x} />
                                <a target={'_blank'} href={x.duong_dan} style={{ flex: 1, fontSize: 11 }}>
                                    {x.ten_file}
                                </a>
                                <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setFileDinhKemChiTietDeletedId(x.id);
                                    }}
                                >
                                    <i style={{ fontSize: 11 }} className='fas fa-trash icon trash'></i>
                                </a>
                            </div>
                        );
                    })}
            </div>
        );
    };
    const filesRender = () => {
        return (

            <div>
                {selectedFiles && (
                    <div className={styles.selected_files_list}>
                        {selectedFiles.map((file, index) => (
                            <div key={index} className={styles.selected_file_item}>
                                <div className={styles.file_name}> {index + 1}. {file.name} <span style={{ marginTop: 5, marginRight: 20 }}
                                    className='fas fa-trash icon trash' onClick={() => handleDeleteFile(index)}
                                >
                                </span> <br /></div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };
    const handleGetEmaiFileDinhKem = async () => {
        const res = await emailFileDinhKemChiTietApi.SelectByMauThuId(formData.id);
        if (res.is_success) {
            setAttachFilesUploaded(res.data);
        }
    }
    const handleDeleteFileDinhKemChiTiet = async () => {
        const res = await emailFileDinhKemChiTietApi.DeleteChiTiet(fileDinhKemChiTietDeletedId);
        if (res.is_success) {
            handleGetEmaiFileDinhKem();
            setFileDinhKemChiTietDeletedId(0);
        }
    };
    const FilePreView = ({ file }) => {
        if (!file || !file.ten_file) {
            return null;
        }
        const imgExtensions = ['jpg', 'png', 'jpeg'];
        const fileExtension = file.ten_file.split('.')[file.ten_file.split('.').length - 1];
        return (
            <div
                style={{
                    display: 'flex',
                    width: 30,
                    justifyContent: 'center',
                }}
            >
                {imgExtensions.includes(fileExtension) && (
                    <img
                        src={file.duong_dan}
                        style={{
                            width: 20,
                            borderRadius: '2px',
                        }}
                    />
                )}
                {fileExtension == 'pdf' && (
                    <img
                        src='../../images/pdf.png'
                        style={{
                            width: 20,
                        }}
                    />
                )}
                {!imgExtensions.includes(fileExtension) && fileExtension != 'pdf' && (
                    <img
                        src='../../images/document.png'
                        style={{
                            width: 20,
                        }}
                    />
                )}
            </div>
        );
    };
    return (
        <div>
            <Modal
                open={true}
                size="large"
                dimmer={'blurring'}
                onClose={() => {
                    // setisShowEditModal(false)
                }}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>

                    {formData.id > 0 ? <p>{'Cập nhật mẫu thư tuyển sinh'}</p> : <p>{'Thêm mới mẫu thư tuyển sinh'}</p>}

                </Modal.Header>
                <Modal.Content>
                    <div className="row">
                        <div className="col-md-12">
                            <FormGroup label={"Tên mẫu thư tuyển sinh"}>
                                <TextBox stylingMode="outlined"
                                    value={formData.ten_mau}
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            setFormData({ ...formData, ten_mau: e.value })
                                        }
                                    }}
                                />
                            </FormGroup>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-6 padding-top-1rem">
                            <ComboboxTruong
                                width='100%'
                                value={formData.dm_truong_id}
                                dm_coso_id={dm_coso_id}
                                showClearButton={true}
                                onValueChanged={(value) => {
                                    setFormData({ ...formData, dm_truong_id: value })

                                }}
                            />
                        </div>
                        <div className="col-md-6 padding-top-1rem">
                            <DefaultButton
                                text={"File đính kèm"}
                                icon={"fa fa-file"}
                                onClick={toggleFileInput}
                            />
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup label={"Tên hiệu trưởng"}>
                                <TextBox stylingMode="outlined"
                                    value={formData.ten_ht}
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            setFormData({ ...formData, ten_ht: e.value })
                                        }
                                    }}
                                />
                            </FormGroup>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12 padding-top-1rem">
                            <CheckBox
                                value={formData.dinh_kem_ket_qua_thi}
                                onValueChanged={() => setFormData({ ...formData, dinh_kem_ket_qua_thi: !formData.dinh_kem_ket_qua_thi })}
                                text={'Đính kèm kết quả thi'}
                            />
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-md-12">
                            <FormGroup label={"Nội dung thư"}>
                                <NoiDungModal
                                    letterTemplate={formData}
                                    dm_truong_id={formData.dm_truong_id}
                                    onSuccess={(value) => {
                                        console.log('value', value)
                                        setFormData({ ...formData, noi_dung_vn: value.noi_dung_vn, noi_dung_en: value.noi_dung_en })
                                    }}
                                />

                            </FormGroup>
                        </div>

                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <button onClick={() => {
                            onClose()
                        }} className="p-btn p-btn-sm">
                            Đóng
                        </button>
                        {
                            !isPreview &&
                            <button
                                // disabled={isSaving}
                                onClick={() => {
                                    handleSubmit()
                                }}
                                className="p-btn p-prim-col p-btn-sm margin-left-10"
                            >
                                {formData.id > 0 ? <p>{'Cập nhật'}</p> : <p>{'Thêm mới'}</p>}
                            </button>
                        }
                    </div>
                </Modal.Actions>
            </Modal>
            {showFileInput && (
                <Modal
                    open={true}
                    size="small"
                    dimmer={'blurring'}
                    onClose={() => {
                        // setisShowEditModal(false)
                    }}
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                    className={styles.modal_center}
                >
                    <Modal.Header>
                        Danh sách file đính kèm
                    </Modal.Header>
                    <Modal.Content>
                        <div >
                            <span
                                className={styles.custom_file_input}
                                onClick={() => inputRef.current.click()}
                            >
                                Tải tệp lên
                            </span>
                            <span className={styles.file_count}>{selectedFiles.length + attachFilesUploaded.length} tệp đã chọn</span>
                            <input
                                type='file'
                                multiple
                                accept='image/*,application/pdf'
                                onChange={handleUploadFiles}
                                ref={inputRef}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className={styles.selected_files_container}>
                            <div className={styles.scrollable_content}>
                                {fileCellRender()}
                                {filesRender()}
                            </div>
                        </div>
                    </Modal.Content>
                    <Modal.Actions>
                        <div className={styles.actions}>
                            <DefaultButton text={"Cập nhật"}
                                onClick={() => {
                                    toggleFileInput()
                                }} />
                        </div>
                    </Modal.Actions>
                </Modal>

            )}
            {fileDinhKemChiTietDeletedId > 0 && (
                <Confirm
                    className={styles.modal_center}
                    open={true}
                    dimmer={'blurring'}
                    header={'Lưu ý'}
                    content={'Bạn có chắc chắn muốn xóa file đính kèm này ?'}
                    size='mini'
                    cancelButton={() => {
                        return (
                            <DefaultButton
                                text={'Đóng'}
                                onClick={() => {
                                    setFileDinhKemChiTietDeletedId(0);
                                }}
                            />
                        );
                    }}
                    confirmButton={() => {
                        return <DangerButton text={'Xóa file'} onClick={handleDeleteFileDinhKemChiTiet} />;
                    }}
                />
            )}
        </div >
    );
};

export default MauThuDetailModal;